export class ExternalModalAdapter {
    protected modalDiv: HTMLDivElement

    public constructor(callback?: () => void) {
        // Construct modal div for use outside of React scope.
        this.modalDiv = document.createElement('div')
        this.modalDiv.classList.add('external-react-modal')

        this.bodyFinder().then((body: Nullable<HTMLElement>): void => {
            if (body) {
                body.appendChild(this.modalDiv)

                if (callback) {
                    callback()
                }
            }
        })
    }

    // Get the body when it exists
    // This is required as on initial startup the server responds so slowly that
    // React can actually run before the body exists properly causing an error.
    protected async bodyFinder(): Promise<Nullable<HTMLElement>> {
        const body: HTMLElement = document.body

        if (body) {
            return body
        }

        return new Promise<Nullable<HTMLElement>>((resolve) => {
            window.addEventListener('DOMContentLoaded', (): void => resolve(this.bodyFinder()))
        })
    }
}
